import React, { useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Button,
} from "reactstrap";
import MasterOutletService from "../../../services/OrderingServices/MasterOutletService";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import OrganizationService from "../../../services/OrderingServices/OrganizationService";
import { useState } from "react";
import Select from "react-select";

const OutletForm = ({ isOpen, toggle, selectedItem, orgId, fetchConfigs }) => {
  const [organizationList, setOrganizationList] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchOrganization = async () => {
    try {
      setLoading(true);
      const response = await OrganizationService.getOrgList();
      setOrganizationList(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchOrganization();
  }, []);
  useEffect(() => {
    if (orgId) {
      formik.setFieldValue("organizationId", orgId);
    }
  }, [orgId]);
  const formik = useFormik({
    initialValues: {
      organizationId: orgId || null,
      code: selectedItem?.code || "",
      name: selectedItem?.name || "",
      address: selectedItem?.address || "",
      phone: selectedItem?.phone || "",
      isActive: selectedItem?.isActive || true,
      isDefault: selectedItem?.isDefault || true,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      organizationId: Yup.mixed().required("Organization is required"),
      code: Yup.string().required("Code is required"),
      name: Yup.string().required("Name is required"),
      address: Yup.string().required("Address is required"),
      phone: Yup.string().required("Phone is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const isEditMode = selectedItem && selectedItem.id;
        const payload = {
          ...values,
          id: values?.id || 0,
          isDefault: values.isDefault || false,
        };
        if (isEditMode) {
          await MasterOutletService.update(selectedItem.id, payload);
          toast.success("Outlet updated successfully");
        } else {
          await MasterOutletService.create(values);
          toast.success("Outlet created successfully");
        }
        fetchConfigs();
        toggle();
        resetForm();
      } catch (error) {
        toast.error(error.message);
      }
    },
  });
  const organizationOptions =
    organizationList?.items?.map((type) => ({
      value: type.id,
      label: type.name,
    })) || [];
  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          {selectedItem ? "Edit Outlet" : "Create Outlet"}
        </ModalHeader>
        <ModalBody>
          <form onSubmit={formik.handleSubmit}>
            <FormGroup>
              <Label for="organizationId">
                Organization <span style={{ color: "#dc3545" }}>*</span>
              </Label>
              <Select
                name="organizationId"
                value={
                  organizationOptions.find(
                    (option) => option.value === formik.values.organizationId,
                  ) || null
                }
                onChange={(selectedOption) => {
                  formik.setFieldValue(
                    "organizationId",
                    selectedOption ? selectedOption.value : null,
                  );
                }}
                onBlur={() => formik.setFieldTouched("organizationId", true)}
                options={organizationOptions}
                placeholder="Select Organization"
                isClearable
                classNamePrefix="react-select"
              />
              <FormFeedback>{formik.errors.organizationId}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="name">Name</Label>
              <Input
                id="name"
                name="name"
                type="text"
                {...formik.getFieldProps("name")}
                invalid={formik.touched.name && !!formik.errors.name}
              />
              <FormFeedback>{formik.errors.name}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="code">Code</Label>
              <Input
                id="code"
                name="code"
                type="text"
                {...formik.getFieldProps("code")}
                invalid={formik.touched.code && !!formik.errors.code}
              />
              <FormFeedback>{formik.errors.code}</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="address">Address</Label>
              <Input
                id="address"
                name="address"
                type="text"
                {...formik.getFieldProps("address")}
                invalid={formik.touched.address && !!formik.errors.address}
              />
              <FormFeedback>{formik.errors.address}</FormFeedback>
            </FormGroup>

            <FormGroup>
              <Label for="phone">Phone</Label>
              <Input
                id="phone"
                name="phone"
                type="text"
                {...formik.getFieldProps("phone")}
                invalid={formik.touched.phone && !!formik.errors.phone}
              />
              <FormFeedback>{formik.errors.phone}</FormFeedback>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  {...formik.getFieldProps("isActive")}
                  invalid={formik.touched.isActive && !!formik.errors.isActive}
                />
                Active
              </Label>
              <FormFeedback>{formik.errors.isActive}</FormFeedback>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input
                  type="checkbox"
                  {...formik.getFieldProps("isDefault")}
                  invalid={
                    formik.touched.isDefault && !!formik.errors.isDefault
                  }
                />
                Default
              </Label>
              <FormFeedback>{formik.errors.isDefault}</FormFeedback>
            </FormGroup>

            <div className="d-flex justify-content-end gap-2 mt-3">
              <Button color="danger" onClick={toggle}>
                Cancel
              </Button>
              <Button color="success" type="submit">
                Save Changes
              </Button>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default OutletForm;
